import { useEffect, useRef, useState } from 'react';

export function useSectionObserver(sectionIds: string[]): string {
  const [activeSection, setActiveSection] = useState(sectionIds[0] ?? '');
  const ratioMap = useRef(new Map<string, number>());

  useEffect(() => {
    if (!sectionIds.length) return;

    // Clear stale ratios so sections from a previously-rendered scope can't keep
    // a hidden item highlighted after a scope swap.
    ratioMap.current.clear();

    const elements = sectionIds
      .map((id) => document.getElementById(id))
      .filter(Boolean) as HTMLElement[];

    if (!elements.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          ratioMap.current.set(entry.target.id, entry.intersectionRatio);
        }

        let best = '';
        let bestRatio = -1;
        for (const [id, ratio] of ratioMap.current) {
          if (ratio > bestRatio) {
            bestRatio = ratio;
            best = id;
          }
        }
        if (best) setActiveSection(best);
      },
      { rootMargin: '-80px 0px -60% 0px', threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
    );

    for (const el of elements) observer.observe(el);
    return () => observer.disconnect();
  }, [sectionIds]);

  return activeSection;
}
